{
  "account": {
    "title": "Mi cuenta",
    "list": {
      "title": "Cuentas",
      "description": "Lista de facturas de las cuentas asociadas"
    },
    "form": {
      "name": {
        "title": "Nombre",
        "description": "Tu nombre de cuenta"
      },
      "password": {
        "title": "Contraseña",
        "description": "Establezca una nueva contraseña para su cuenta, déjela vacía para mantener la contraseña actual"
      },
      "emailPreferences": {
        "title": "Preferencias de correo",
        "description": "Selecciona el tipo de notificación de correo"
      }
    },
    "billing": "Detalles de pago",
    "subscriptions": "Suscripciones",
    "manageSubscription": "Administrar suscripción",
    "popup": {
      "downgrade": "¿Estás seguro de bajar de categoría? La reducción de categoría entrará en vigencia de inmediato.<br/>Tenga en cuenta que no será elegible para un reembolso por el tiempo restante del ciclo de facturación actual.<br/>El precio del nuevo plan se aplicará en el próximo ciclo de facturación.",
      "default": "¿Estás seguro de que quieres cambiar tu plan?",
      "cancel": "¿Estás seguro de cancelar tu suscripción?<br/> Su sitio web seguirá traduciéndose hasta el final de su período de suscripción actual. Después de eso, la traducción estará deshabilitada.<br/> Tenga en cuenta que no será elegible para un reembolso por el período no utilizado.",
      "resume": "¿Estás seguro de reanudar tu suscripción?"
    }
  },
  "ai_translation": {
    "header": "Traducción de IA",
    "plan": {
      "header": "Precios de traducción de IA",
      "used": "Has utilizado {words_used} / {words_allowed} palabras traducidas en tus créditos de IA.",
      "remaining": "Créditos de IA disponibles:",
      "words": "palabras",
      "add_more_credits": "Añadir más créditos de IA",
      "details": {
        "idiomatic_expressions": "Expresiones idiomáticas y técnicas",
        "background_translation": "Traducciones en segundo plano",
        "page_context": "Contexto de la página y del sitio web para la traducción",
        "perfect_quality": "Calidad perfecta, precio asequible.",
        "no_recurring": "Sin pago recurrente, cuota prepaga",
        "save_40": "Ahorre un 40% en comparación con el plan de $20",
        "save_50": "Ahorre un 50% en comparación con el plan de $20",
        "best_website": "Sitio web que requiere una calidad de traducción perfecta"
      },
      "quota": "{estimated_words} palabras ~ {estimated_pages} páginas"
    },
    "settings": {
      "banner": {
        "title": "Traducción de IA de Linguise",
        "intro": "Linguise se complace en presentar Linguise AI Translation, una nueva función premium que aprovecha los modelos LLM de IA (los modelos más recientes de Llama, optimizados para tareas de traducción). Diseñada para sitios web que exigen una precisión impecable, considera el contexto de la página y del sitio web completo para obtener resultados inigualables. Ofrezca a sus clientes la máxima calidad de traducción, garantizando que su mensaje tenga una repercusión perfecta en todos los idiomas.",
        "button": "Actualice ahora"
      },
      "alert": {
        "description": "Esta función no está incluida en tu plan actual y requiere una compra aparte. Activa este complemento para desbloquear todas las opciones que se indican a continuación."
      },
      "languages": {
        "title": "Aplicar la traducción de IA a los idiomas",
        "description": "Seleccione el idioma específico en el que desea que se aplique la traducción de IA"
      },
      "button": {
        "save": "Guardar configuración"
      },
      "form": {
        "rule_application": {
          "description": "Aplicar la traducción de IA en contenido estático o dinámico o ambos",
          "title": "Aplicar al contenido",
          "all": "Todo el contenido",
          "static": "Contenido estático",
          "dynamic": "Contenido dinámico"
        },
        "website_topic": {
          "title": "Tema del sitio web",
          "placeholder": "Restaurante de sushi...",
          "description": "Define el tema de tu sitio web para una mejor calidad de traducción (ej. Legal, restaurante de sushi, tienda online de repuestos de bicicletas…).\nIntroduce el tema del sitio web en inglés."
        },
        "apply_to_urls": {
          "title": "Aplicar a las URL",
          "description": "Seleccione las URL específicas donde desea que se aplique la traducción de IA",
          "all_urls": "Todas las URL",
          "selected_urls": "URL seleccionadas",
          "label": "URL a la que aplicar",
          "placeholder": "URL a la que aplicar",
          "wildcard": "Comodín",
          "regex": "Expresión regular",
          "add": "Añadir nuevo",
          "expression": "Tipo de expresión"
        },
        "apply_languages": {
          "title": "Aplicar a los idiomas",
          "description": "Seleccione el idioma específico en el que desea que se aplique la traducción de IA",
          "all_languages": "Todos los idiomas",
          "selected_languages": "Idiomas seleccionados",
          "placeholder": "Seleccionar idiomas...",
          "feedback": "Debes elegir un idioma"
        },
        "enable_mode": {
          "title": "HABILITAR LA TRADUCCIÓN DE IA",
          "description": "Elige cómo quieres que se habilite la traducción de IA.\nSólo se aplicarán las siguientes reglas.\nEl editor en vivo solo permitirá habilitar la traducción página por página desde la vista del editor en vivo.\nLas reglas y el editor en vivo utilizarán ambas funciones.",
          "disabled": "Desactivado",
          "rules": "Solo reglas",
          "live_editor": "Solo editor en vivo",
          "all": "Reglas y editor en vivo"
        },
        "formality": {
          "title": "Formalidad",
          "description": "Especifique el grado de formalidad en las traducciones, posiblemente importante para el público y el contexto.\n\"Neutral\" intentará preservar la formalidad del contenido original.\n\"Formal\" se refiere a contenido profesional, comercial o legal (es decir, se usan pronombres formales como \"usted\" en español).\n\"Informal\" se refiere a contenido informal y conversacional (es decir, se usa \"tú\" en español).",
          "neutral": "Neutral",
          "formal": "Formal",
          "informal": "Informal"
        },
        "sentence_structure": {
          "classic": "Clásico",
          "short": "Frases cortas y contundentes",
          "detailed": "Oraciones detalladas y explicativas",
          "title": "Estructura de la oración",
          "description": "Define la preferencia de estilo de escritura."
        },
        "content_purpose": {
          "marketing": "Marketing/promoción (tono persuasivo y atractivo)",
          "technical": "Técnico/instructivo (claro, preciso, orientado a la acción)",
          "support": "Atención al cliente (empático, servicial, tranquilizador)",
          "legal": "Legal/cumplimiento (preciso, formal, inequívoco)",
          "educational": "Educativo (claro, estructurado, accesible)",
          "title": "Propósito del contenido",
          "description": "Definir el propósito funcional del contenido que se está traduciendo.",
          "other_placeholder": "Describe el propósito...",
          "other": "Otro (en inglés)"
        },
        "target_audience": {
          "title": "Público objetivo",
          "description": "Especificación de la audiencia prevista del contenido traducido (en inglés).",
          "placeholder": "Por ejemplo, padres hispanohablantes, responsables de privacidad de la UE."
        },
        "advanced": {
          "title": "Instrucciones avanzadas de IA",
          "description": "Instrucciones avanzadas de IA"
        },
        "override_default_translations": {
          "title": "Anular la traducción predeterminada",
          "description": "Si se configura en SÍ, esta opción forzará la traducción del contenido con IA (Linguise AI) incluso si ya ha sido traducido por Cloud AI Translation (modelo de traducción predeterminado)."
        },
        "force_replace_before": {
          "title": "Forzar la retraducción con IA",
          "description": "Vuelve a traducir con IA cualquier contenido cuya traducción con IA se creó antes de la fecha seleccionada, por ejemplo, contenido traducido con un modelo anterior. La retraducción se realizará en la próxima visita a las páginas correspondientes según las reglas y consumirá tus créditos de IA.",
          "before_date": "Antes de una fecha"
        },
        "model": {
          "current": "Actual",
          "title": "Modelo",
          "description": "Seleccione el modelo de traducción LLM que desea utilizar",
          "load_error": "No se pueden cargar los modelos disponibles. Por favor, inténtelo de nuevo más tarde.",
          "thinking_warning": "Este modelo utiliza un alto nivel de razonamiento (\"pensamiento\") y consumirá significativamente más tokens por traducción."
        },
        "override_manual_and_selected": {
          "no_default": "No (predeterminado)",
          "title": "Sobrescribir traducciones manuales y seleccionadas",
          "description": "De forma predeterminada, una traducción que editaste manualmente permanece siempre en tu sitio web, incluso después de generarse una traducción mejorada con IA. Elige «Sí» para mostrar en su lugar la traducción mejorada con IA. Tus traducciones manuales se conservan y puedes volver atrás en cualquier momento. Esto también se aplica cuando vuelves a traducir las páginas para obtener nuevas traducciones; se utilizará automáticamente la más reciente."
        }
      },
      "message": {
        "save_success": "Del contenido actual ya traducido, la cantidad de páginas que se podrían mejorar con la traducción de IA es de aproximadamente {{ai_affected_urls}}.",
        "save_success_only": "Configuración guardada exitosamente."
      }
    },
    "pricing": {
      "plan": {
        "title": "Solicitar cuota de traducción de IA",
        "buy_button": "COMPRAR PAQUETE DE TRADUCCIÓN DE IA"
      },
      "modal": {
        "title": "Confirmar cambio de plan",
        "description": "¿Está seguro de que desea cambiar su plan de traducción de IA?",
        "button_cancel": "Cancelar",
        "button_confirm": "Confirmar",
        "loading": "Espere por favor...",
        "amount": "Cantidad",
        "credit": "Crédito",
        "total_due": "Total adeudado"
      },
      "comparison": {
        "title": "Traducción con IA de Google Cloud frente a traducción con IA de Linguise",
        "list": {
          "0": {
            "google": "Traducciones rápidas y fiables",
            "linguise": "Manejar expresiones idiomáticas y técnicas"
          },
          "1": {
            "google": "Traducciones instantáneas de todas las páginas del sitio web",
            "linguise": "Generación de las traducciones en segundo plano"
          },
          "2": {
            "google": "La mejor calidad, el precio más bajo",
            "linguise": "Calidad perfecta, precio asequible."
          },
          "3": {
            "google": "Ideal para sitios web grandes o de bajo presupuesto.",
            "linguise": "Ideal para sitios web que requieren una calidad de traducción perfecta."
          },
          "4": {
            "google": "Contexto de la página para la traducción",
            "linguise": "Contexto de la página y del sitio web para la traducción"
          }
        }
      },
      "botom_banner": {
        "title": "Experimente una precisión de traducción inigualable con el",
        "sub_title": "Nueva traducción de inteligencia artificial de Linguise",
        "description": "Linguise mejora sus servicios de traducción automática con la introducción de Linguise AI Translation, una potente opción que utiliza la tecnología de traducción con IA LLM (modelos Llama más recientes optimizados para traducciones). Esta incorporación ofrece a desarrolladores y agencias web una calidad de traducción aún mayor, ideal para proyectos donde la perfección es fundamental. Linguise AI Translation complementa nuestro servicio de traducción con IA de alta calidad de Google Cloud, ofreciéndole mayor flexibilidad y precisión."
      }
    },
    "success": {
      "tab_title": "¡Gracias por comprar el plan AI Translation!",
      "title": "¡Gracias por comprar el plan AI Translation!",
      "subtitle": "¡Tu plan de Traducción IA ha sido comprado exitosamente!",
      "message": "Puede administrar su plan de Traducción de IA en la página de configuración de Traducción de IA.",
      "home": "Gestionar la traducción de IA"
    }
  },
  "billing": {
    "form": {
      "name": {
        "title": "Nombre",
        "description": "Nombre para la cuenta de pagos"
      },
      "phone": {
        "title": "Teléfono",
        "description": "Número de teléfono para la cuenta de pagos"
      },
      "email": {
        "title": "Correo",
        "description": "Correo para la cuenta de pagos"
      },
      "address": {
        "title": "Dirección",
        "description": "Dirección para la cuenta de pagos",
        "city": "Ciudad",
        "country": "País",
        "address1": "Dirección 1",
        "address2": "Dirección 2",
        "postal": "Código postal",
        "state": "Estado"
      },
      "tax": {
        "title": "Número de impuesto"
      }
    }
  },
  "checkouts": {
    "header": "Verificar",
    "payment_method": "Seleccione método de pago",
    "stripe_card": "Tarjeta de crédito (Raya)",
    "paypal": "PayPal",
    "address": {
      "new": "Introduce una nueva dirección de facturación",
      "existing": "Usar dirección existente"
    },
    "pay_stripe": "Confirmar y pagar",
    "terms": "Al confirmar su suscripción, permite que Linguise le cobre por pagos futuros de acuerdo con nuestros términos. Siempre puedes cancelar tu suscripción.",
    "coupon": {
      "title": "¿Tienes un cupón?",
      "placeholder": "Inserta tu código de cupón aquí",
      "apply": "Aplicar",
      "percent": "{{0}}% de descuento"
    },
    "add_new": "Agregar nuevo",
    "use_existing": "Utilice el método de pago existente",
    "recurring": {
      "month_single": "Facturado mensualmente",
      "month_many": "Facturado cada {{count}} meses",
      "year_single": "Facturado anualmente",
      "year_many": "Facturado cada {{count}} años",
      "day_single": "Facturado diariamente",
      "day_many": "Facturado cada {{count}} días",
      "week_single": "Facturado semanalmente",
      "week_many": "Facturado cada {{count}} semanas"
    },
    "add_new_no_stripe": "Agregar nueva tarjeta",
    "summary": {
      "title": "Resumen",
      "subtotal": "Total parcial",
      "total": "Total"
    }
  },
  "dashboard": {
    "main": {
      "title": "Panel"
    },
    "statistics": {
      "main_title": "Estadísticas de los últimos 30 días",
      "characters": "Caracteres traducidos",
      "words": "Palabras traducidas",
      "bandwidth": "Entrada de ancho de banda",
      "request": "Peticiones",
      "page_views": "Páginas vistas por idioma (últimos 30 días)",
      "multilingual_views": "Páginas multilingües vistas (últimos 30 días)",
      "most_page_viewed": "20 páginas más vistas (últimos 30 días)",
      "no_data_yet": "Aún no hay datos disponibles",
      "th_language": "Idioma",
      "th_page_views": "Páginas vistas",
      "real_visitors": "Visitantes reales",
      "crawler": "Rastreador web"
    },
    "planHints": {
      "subscribeButton": "Suscríbete",
      "upgradeButton": "Mejorar",
      "usedWords": "Actualmente estás {words_used} palabras",
      "noPlan": "No hay plan activado para este dominio. Suscríbete a un plan y empieza a traducir tu sitio web",
      "trialUsage": "Usted está utilizando actualmente {words_used} palabras de las {words_allowed} palabras incluidas en tu prueba.",
      "trialEnds": "La prueba del 1er mes está activada hasta {trial_ends}.",
      "subscribeMessage": "Súscribete antes de que termine para mantener tu sitio web traducido",
      "trialReachedLimit": "Alcanzaste el máximo número de palabras traducidas para tu periodo de prueba.\nSuscribase a uno de nuestros planes para seguir traduciendo su sitio web.",
      "paidUsage": "Has utilizado {words_used} palabras de las {words_allowed} palabras disponibles en tu plan.",
      "paidReachedLimit": "Alcanzaste el número máximo de palabras traducidas para tu plan.\nMejora tu plan para seguir traduciendo el contenido de tu sitio web.",
      "trialOfferedUsage": "Actualmente estás usando {words_used} palabras de las {words_allowed} palabras incluidas en el plan de prueba.(Incluidas las {free_words} palabras ofrecidas)",
      "paidOfferedUsage": "Ha utilizado {words_used} / {words_allowed} palabras traducidas en su plan.(Incluidas las {free_words} palabras ofrecidas)",
      "noPlanExtra": "Tenga en cuenta que los dominios inactivos y sus datos se eliminan automáticamente con regularidad.",
      "planRecommended": "Según su volumen de traducción actual, el plan recomendado es:",
      "planMaximumWords": "{{words}} palabras",
      "notHaveTranslatedWords": "Aún no has hecho ninguna traducción.",
      "noPlanShopify": "No hay ningún plan activado para este dominio. Suscríbete a un plan en tu panel de control de Shopify y empieza a traducir tu sitio web.",
      "subscribeMessageShopify": "Suscríbete desde tu panel de Shopify antes de que finalice para mantener tu sitio web traducido"
    },
    "translationSetup": {
      "kicker": "CONFIGURACIÓN DEL SUBDOMINIO",
      "title": "Comprobar la configuración de traducción",
      "description": "Revisa el DNS, los hosts traducidos, el acceso al sitio original y los límites de la cuenta.",
      "starting": "Comprobando...",
      "button": "Comprobar configuración",
      "viewLatest": "Ver último resultado",
      "viewCurrent": "Ver comprobación actual",
      "runAgain": "Volver a comprobar",
      "viewDetails": "Ver detalles",
      "hideDetails": "Ocultar detalles",
      "error": "No se pudo comprobar la configuración",
      "allPassed": "Todas las comprobaciones se superaron",
      "setupNeedsAttention": "La configuración requiere atención",
      "setupNeedsAttentionDescription": "Una o varias comprobaciones fallaron. Revisa los elementos siguientes o contacta con el soporte de Linguise.",
      "lastChecked": "Última comprobación: {{time}}",
      "domainOwnership": "Propiedad del dominio",
      "domainOwnershipDescription": "Se encontró el registro de verificación",
      "domainOwnershipFailure": "No se pudo verificar el registro DNS de propiedad.",
      "translatedHosts": "Hosts traducidos",
      "translatedHostsDescription": "Se comprobaron {{count}} hosts de idioma",
      "translatedHostsFailure": "Uno o varios registros CNAME de idioma son incorrectos.",
      "subdomainPage": "Página del subdominio",
      "subdomainPageDescription": "{{count}} páginas traducidas aceptan HTTPS",
      "subdomainPageFailure": "La conexión TLS falló al abrir una o varias páginas traducidas.",
      "originalSite": "Sitio original",
      "originalSiteDescription": "Comprobaciones de DNS, TLS y respuesta del sitio original",
      "originalSiteFailure": "Falló la comprobación de DNS, TLS o respuesta del sitio original.",
      "documentationAdvice": {
        "dns": "Revisar configuración DNS",
        "tls": "Revisar configuración HTTPS",
        "origin": "Revisar configuración del sitio original",
        "diagnostic": "Revisar los pasos para solucionar problemas"
      },
      "evidence": {
        "originDns": "DNS original",
        "originTls": "TLS original",
        "originHttp": "Respuesta original",
        "observedTargets": "Destinos detectados",
        "recordCount": "Registros encontrados",
        "addressCount": "Direcciones encontradas",
        "statusCode": "Estado HTTP",
        "redirect": "Redirección",
        "expiresAt": "El certificado caduca",
        "raw": "{{key}}",
        "noValue": "Sin valor"
      },
      "checkerError": "No se pudieron completar algunas comprobaciones.",
      "coreLocation": "Comprobado desde {{location}}",
      "status": {
        "queued": "En cola",
        "running": "En curso",
        "completed": "Completado",
        "failed": "Fallido",
        "passed": "Superado",
        "warning": "Advertencia",
        "unknown": "Desconocido",
        "skipped": "Omitido",
        "not_applicable": "No aplicable"
      }
    },
    "throttling": {
      "title": "Límite de traducción",
      "description": "Límites de uso temporales",
      "unavailable": "Los límites temporales de traducción no están disponibles",
      "window": "{{used}} / {{max}} palabras",
      "resetsIn": "Se restablece en {{time}}",
      "throttled": "Traducción pausada temporalmente",
      "throttledDescription": "Se alcanzó un límite de uso temporal. La traducción se reanudará cuando se restablezca este periodo."
    }
  },
  "domain": {
    "wizard": {
      "stepLabel": "Paso {{step}} de {{total}}",
      "doneLabel": "HECHO, ¡YA PUEDES EMPEZARA TRADUCIR!",
      "finish": {
        "title": "",
        "description": "Este es el API key que utilizarás en tu sitio web"
      },
      "instructions": "Instrucciones de instalación",
      "domainSetting": "Configuración del dominio",
      "step": {
        "titleWordpress": "Wordpress",
        "titleJoomla": "Joomla",
        "titlePHP": "Guión PHP",
        "wizardWordpressStep1": "1. Instale el ",
        "wizardWordpressStep2": "\n 2. En la configuración del plugin copie y rellene su clave API\n",
        "wizardWordpressStep3": "3. Estás listo para traducir\n\n",
        "wizardWordpressStep4": "Para obtener instrucciones más detalladas, consulte nuestra documentación: ",
        "wizardJoomlaStep1": "1. Enlace al paquete de Joomla: ",
        "wizardJoomlaStep2": "\n2. En los ajustes de configuración de la extensión copie y rellene su clave API",
        "wizardJoomlaStep4": "\n 4. Estás listo para traducir\n\n",
        "wizardJoomlaStep3": "3. En la configuración del módulo, establezca los idiomas que desea mostrar, e inserte su módulo donde lo necesite.",
        "wizardPhpStep1": "1. Descargue nuestro script php y aquí ",
        "wizardPhpStep2": "\n2. Siga las instrucciones de instalación en nuestra página de documentación aquí ",
        "wizardPhpStep3": "\n3. Añade el módulo a tus páginas.",
        "wizardPhpStep4": "\n Copie el siguiente código y añádalo a la cabecera de su página html para que se muestre el módulo del conmutador automáticamente\n",
        "dispatchStep1": "Hemos enviado con éxito los datos requeridos al complemento Linguise, ahora puede cerrar la siguiente ventana.",
        "dispatchStep2": "En caso de que falte el token al cerrar esta ventana, copie el siguiente token:",
        "dispatchStep3": "También puedes copiar este fragmento para habilitar automáticamente nuestro selector de banderas.",
        "wizardOtherStep1": "Siga las instrucciones a continuación para instalar Linguise en su dominio.",
        "wizardOtherStep2": "Copie el siguiente código y agréguelo al encabezado de su página html; mostrará el módulo conmutador automáticamente."
      },
      "trialAlreadyUsed": "Parece que ya utilizaste tu prueba gratis, así que necesitaras pedir tu cuota de traducción\nPor favor suscríbase a un plan o contáctenos si necesita extender su prueba.",
      "usefulLinks": "Links útiles para empezar",
      "linkDocumentation": "Documentación",
      "linkExtensionDl": "Descarga de extensiones",
      "linkSubscribe": "Suscríbase a un plan ahora",
      "linkDashboard": "Ve al panel",
      "exclusion": {
        "title": "Compañia y nombre de productos",
        "description": ""
      },
      "finishButton": "Finaliza la configuración",
      "subdomains": "Subdominios",
      "subdomain_setup": "Dominio de configuración",
      "subdomain_auto_setup": "Conecta tu DNS automáticamente",
      "subdomain_manual_setup": "Agregar entradas DNS yo mismo",
      "subdomain_skip": "Agregar entradas DNS yo mismo",
      "auto_subdomains_info": "El CMS de su creador de sitios requiere una configuración de DNS para establecer los idiomas por subdominio (por ejemplo, es.dominio.com). Puedes hacerlo automáticamente usando Entri. Simplemente haga clic en el botón \"Conectar su DNS automáticamente\" para comenzar a conectarse a su administrador de DNS y agregarlos con Entri. ",
      "auto_subdomains_info_manual": "O puede configurar manualmente su dominio haciendo clic en el botón \"Agregar entradas DNS yo mismo\".",
      "auto_subdomains_info_2": "Puedes hacerlo automáticamente usando Entri. Simplemente haga clic en el botón \"Conectar su DNS automáticamente\" para comenzar a conectarse a su administrador de DNS y agregarlos con Entri. ",
      "breadcrumbs": {
        "step1": "Paso 1: Dominio, CMS e idiomas",
        "step2": "Paso 2: DNS del idioma",
        "step3": "Paso {{step}}: Instrucciones de instalación"
      }
    },
    "form": {
      "urls": {
        "dash": "Guion -",
        "underscore": "Guion bajo _",
        "title": "Traduce las URLs",
        "description": "¿Quieres traducir todas las páginas?",
        "char_description": "Este es el carácter que utilizarás para reemplazar caracteres no autorizados en la URL",
        "advertisement_title": "⚠ Usted ha establecido muchos idiomas.\n",
        "advertisement": "Normalmente aconsejamos empezar a traducir sitios web con pocos idiomas al principio. Así tendrá una idea de la cantidad de palabras que tiene su sitio web. \nTambién es mejor para el SEO, ya que los robots de Google rastrearán más rápidamente todas tus páginas si tienes menos páginas al principio.\nDespués de una semana puedes añadir algunos idiomas más y así sucesivamente."
      },
      "url": {
        "title": "Url",
        "description": "Añade tu dominio principal URL empezando con http:// o https://",
        "placeholder": "URL de dominio",
        "advertisement_http": {
          "title": "No estás usando el protocolo https",
          "description": "Compruebe que su dominio no esté utilizando el protocolo https, que se recomienda actualmente."
        },
        "advertisement_www": {
          "title": "Tu subdominio no es www",
          "description": "La mayoría de las veces, el subdominio predeterminado es www (como https://www.mydomain.com). Puede que este no sea su caso, pero verifique que el dominio que desea agregar sea el correcto."
        },
        "invalid_url": {
          "line1": "No hemos podido encontrar su dominio. Verifique que su dominio sea accesible públicamente a través de Internet y que no esté redirigido a otra ubicación. ",
          "line2": "Si está seguro de que su dominio es accesible, puede omitir la verificación del dominio y presionar el botón \"Siguiente paso\" nuevamente.",
          "contact": "En cualquier caso puedes contactar con nosotros en",
          "force": "Saltar verificación de dominio"
        },
        "invalid_subdomain_url": "Esta URL no está permitida. Los subdominios deben tener el formato: https://www.dominio.tld o https://dominio.tld sin subdirectorio."
      },
      "account": {
        "title": "Cuenta",
        "description": "Seleccione una cuenta para asignar este dominio",
        "placeholder": "Seleccionar cuenta...",
        "feedback": "Debes elegir una cuenta"
      },
      "platform": {
        "title": "Plataforma",
        "description": "Seleccione la plataforma de su sitio web por el nombre del CMS.",
        "learn": "Aprende a elegirlo",
        "placeholder": "Buscar plataforma por nombre de CMS...",
        "info": {
          "title": "⚠ Esta plataforma se ha agregado recientemente.\n",
          "desc": "Esta plataforma de creación de sitios web es compatible con Linguise, aunque se agregó recientemente. Si tiene algún problema, comuníquese con nosotros mediante el correo electrónico de soporte directo:"
        },
        "description_read_only": "La plataforma que utiliza su sitio web",
        "feedback": "Debes elegir una plataforma"
      },
      "language": {
        "title": "Idioma",
        "description": "Selecciona el idioma base de tu sitio web",
        "placeholder": "Selecciona un idioma...",
        "feedback": "Tienes que elegir un idioma",
        "description_read_only": "Idioma base de tu sitio web"
      },
      "token": {
        "title": "Clave API",
        "description": "Esta es la llave API que copiarás en tu sitio web",
        "copy": "Copiar al portapapeles",
        "reset": "Reiniciar API Key",
        "reset_confirm": "Por favor confirma el reinicio del API Key"
      },
      "languages": {
        "title": "Idiomas de traducción",
        "description": "Selecciona los idiomas a los que quieres traducir tu página",
        "placeholder": "Selecciona los idiomas...",
        "feedback": "Tienes que seleccionar un idioma"
      },
      "defaultRules": {
        "title": "Reglas predeterminadas",
        "description": "Hemos definido un conjunto de reglas de uso obligatorio para mejorar la traducción y evitar que se traduzca contenido no deseado, como el panel de WordPress.\nPuede eliminar o editar estas reglas más tarde si lo desea."
      },
      "disallow_deletion": "No se puede eliminar el dominio con la suscripción activa",
      "delete_confirm": "Por favor confirma la eliminación del dominio",
      "delete": "Eliminar dominio",
      "dynamic": {
        "title": "Traducir contenido dinámico",
        "description": "El contenido dinámico generado por la solicitud de JavaScript y AJAX se traducirá (esta opción aumentará sus usos de traducción)"
      },
      "partial_translations": {
        "title": "Permitir traducción parcial",
        "description": "Si su cuenta alcanzó su cuota de traducción pero la página aún requiere traducción, Linguise puede continuar mostrando la página con el contenido que ya ha sido traducido. Sin embargo, algunas partes de la página permanecerán sin traducir hasta que actualice su cuota. Si bien una pequeña cantidad de contenido sin traducir generalmente no daña el SEO, permitir demasiado contenido sin traducir podría afectar negativamente la experiencia del usuario. Para solucionar este problema, puede establecer un umbral para el porcentaje de contenido no traducido permitido en una página. Si el contenido no traducido supera este umbral, los usuarios serán redirigidos automáticamente a la versión en el idioma original de la página.",
        "never": "Nunca"
      },
      "translate_error_pages": {
        "title": "Traducir páginas de error",
        "description": "Linguise puede traducir todas las páginas de error; sin embargo, si su página de error contiene contenido dinámico, como dirección IP o ID de solicitud, debe evitar traducir estas páginas.",
        "not_found_page": {
          "title": "Traducir página 404"
        },
        "error_page": {
          "title": "Traducir otras páginas de error"
        }
      },
      "plugin_mode": {
        "modal": {
          "title": "Dominio existente encontrado",
          "description": "Se ha encontrado un dominio existente para este usuario, ¿desea utilizarlo?"
        }
      },
      "search_tl": {
        "title": "Buscar traducciones",
        "description": "Habilite las traducciones de búsqueda para la plataforma de su sitio web (experimental, esta opción aumentará sus usos de traducción)"
      },
      "shopify_promo": {
        "info": "¡Buenas noticias! Ya tenemos una app nativa de Shopify que puedes instalar desde la App Store de Shopify.",
        "hyperlink": "Haga clic aquí y realice la instalación de Linguise desde la aplicación.",
        "next_btn": "Vaya a la tienda Shopify para instalar la aplicación",
        "info_legacy": "¡Buenas noticias! Ya tenemos una app nativa de Shopify que puedes instalar desde la App Store de Shopify.",
        "description_legacy": "Seleccione la plataforma \"Shopify\" en lugar de \"Shopify Legacy\""
      },
      "wix_promo": {
        "info": "¡Buenas noticias! Ya tenemos una app nativa de Wix que puedes instalar desde Wix App Market.",
        "hyperlink": "Haga clic aquí y realice la instalación de Linguise desde la aplicación.",
        "next_btn": "Vaya a Wix App Market para instalar la aplicación",
        "info_legacy": "¡Buenas noticias! Ya tenemos una app nativa de Wix que puedes instalar desde Wix App Market.",
        "description_legacy": "Seleccione la plataforma \"Wix\" en lugar de \"Wix Legacy\""
      },
      "ai_disallow_deletion": "No puedes eliminar este dominio mientras haya una cuota de IA disponible. Si quieres eliminarlo, contacta con nuestro equipo de soporte.",
      "language_removal": {
        "card": {
          "title": "Eliminar las traducciones de los idiomas eliminados",
          "description": "Estos idiomas se eliminaron de tu sitio web, pero sus traducciones guardadas siguen contando para tu cuota. Elimínalas para recuperar esas palabras.",
          "button": "Eliminar traducciones"
        },
        "hint": "Las palabras utilizadas volverán a tu cuota. Puedes hacerlo una vez cada {{days}} días por sitio web.",
        "modal": {
          "title": "¿Eliminar traducciones?",
          "intro": "Estas traducciones se eliminarán de forma permanente:",
          "warning": "Esta acción no se puede deshacer. Las palabras utilizadas volverán a tu cuota, lo que puede tardar unos minutos.",
          "limit": "Puedes hacerlo una vez cada {{days}} días por sitio web.",
          "confirm": "Eliminar traducciones"
        },
        "scheduled": "Se están eliminando las traducciones y tu cuota se actualizará en breve.",
        "cooldown": "Las traducciones de este sitio web se eliminaron hace poco. Podrás eliminarlas de nuevo el {{date}}.",
        "latest_completed": {
          "title": "Última eliminación completada",
          "description": "Consulta los idiomas eliminados y las palabras devueltas a tu cuota.",
          "languages": "Idiomas eliminados",
          "words_returned": "Palabras devueltas a tu cuota: {{words}}",
          "completed_at": "Completado el {{date}}"
        },
        "status": {
          "recent_title": "Eliminación reciente de traducciones",
          "recent_description": "Sigue la última eliminación y consulta cuándo podrás iniciar otra.",
          "progress_title": "Progreso de la eliminación",
          "loading": "Comprobando el progreso de la eliminación...",
          "unavailable": "No se pudo cargar el progreso de la eliminación. Actualiza la página e inténtalo de nuevo.",
          "label": "Estado",
          "pending": "En cola",
          "processing": "En curso",
          "completed": "Completado",
          "failed": "Error",
          "unknown": "Estado no disponible",
          "percent": "{{percent}} % completado",
          "current_stage": "Paso actual: {{stage}}",
          "processed": "{{processed}} registros procesados",
          "processed_total": "{{processed}} de {{total}} registros procesados",
          "requested_at": "Solicitado el {{date}}",
          "started_at": "Iniciado el {{date}}",
          "completed_at": "Completado el {{date}}",
          "cooldown_period": "Puedes hacerlo una vez cada {{days}} días por sitio web.",
          "cooldown_blocked": "Aún no se puede iniciar otra eliminación.",
          "stage": {
            "queued": "Esperando para comenzar",
            "processing": "En curso",
            "refund_summary": "Calculando las palabras devueltas",
            "search_translations": "Eliminando traducciones de búsqueda",
            "url_translations": "Eliminando traducciones de URL",
            "translations": "Eliminando traducciones",
            "completed": "Completado",
            "failed": "Error",
            "unknown": "En curso"
          }
        },
        "forbidden": "No tienes permiso para eliminar traducciones."
      }
    },
    "main": {
      "edit": "Editar dominio",
      "add": "Agregar dominio",
      "wizard": "¡Bienvenido! Ayudante de creación de nuevo dominio",
      "common": "Dominio"
    },
    "subdomains": {
      "config_ok": "El DNS de subdominios se ha configurado correctamente.",
      "config_invalid": "El DNS de subdominios requiere alguna configuración adicional para funcionar.",
      "config_check": "Se está verificando la configuración DNS de los subdominios, espere...",
      "entri_timeout": "Entri informó que el proceso de propagación de DNS de sus subdominios expiró; deberá volver a intentarlo o puede hacerlo manualmente.",
      "entri_process": "Su DNS se ha agregado con Entri y normalmente tarda entre 10 y 30 minutos en propagarse (aplica todos los subdominios de idiomas como es.domain.com). Si la validación de DNS no finaliza después de 24 horas, puede comunicarse con nuestro equipo de soporte: support@linguise.com ",
      "entri_ok": "¡La propagación de DNS está en camino! Esperando la propagación... ",
      "infos": "Debe agregar estas entradas DNS a sus registros de dominio DNS para activar la traducción. Haga clic en el botón de verificación cuando esté listo. Es posible que los registros DNS tarden un tiempo en propagarse, por lo que podría tener que volver después de unos minutos u horas.",
      "check": "Comprobar la configuración de DNS"
    },
    "notice": {
      "broken_card": "No pudimos renovar su plan para {{url}} usando el método de pago actual, actualice su tarjeta de pago",
      "quota_reached": "Se alcanzó su cuota de traducción para {{url}}. Actualice para reanudar la traducción de su sitio web",
      "important": "Importante",
      "quota_reached_button": "Actualiza tu plan ahora",
      "broken_card_button": "Actualiza tu tarjeta de pago",
      "ai_no_subscription": "La traducción de IA para {{url}} requiere una suscripción o prueba activa. Se detendrá sin una suscripción. Actualice para continuar.",
      "ai_no_subscription_button": "Actualice su plan ahora",
      "quota_warning": "Su cuota de traducción para {{url}} ha alcanzado el {{throttling_used_percent}}%, se restablecerá en {{ttl}}",
      "locked": "El dominio {{url}} está actualmente bloqueado para la migración. Aún puede acceder a su sitio, pero no puede editar ni agregar nuevas traducciones."
    },
    "subscription": {
      "next_payment_amount": "Próximos cargos",
      "next_payment_date": "Próxima fecha de pago",
      "invoice": {
        "header": "Historial de facturas",
        "date": "Fecha",
        "amount_due": "Cantidad",
        "status": "Estado",
        "actions": "Comportamiento",
        "description": "Una vez que las transacciones estén disponibles, podrá verlas aquí.",
        "status_text": {
          "draft": "Borrador",
          "open": "Pendiente",
          "paid": "Pagado",
          "uncollectible": "Incobrable",
          "void": "Vacío",
          "failed": "Fallido",
          "retrying": "Volver a intentar"
        },
        "view": "Vista",
        "empty": "No se encuentran facturas recientes para esta suscripción.",
        "retry_payment": "Rever"
      },
      "next_cancellation": "Fecha de cancelación",
      "cancel": "Cancelar suscripción",
      "change_plan": "Cambiar de plan",
      "change": "Cambiar",
      "suspend": "suspender pago",
      "resume": "Reanudar suscripción",
      "back": "Atrás",
      "save": "Ahorrar",
      "confirm_resume": "¿Está seguro de que desea reanudar esta suscripción?",
      "confirm_cancel": "¿Estás seguro de que deseas cancelar esta suscripción?",
      "confirm_header": "¿Está seguro?",
      "missing_status": "Falta esta suscripción",
      "not_found": "No se encontró ninguna suscripción para este dominio",
      "no_payment_method": "Desconocido",
      "remove_billing": "Eliminar",
      "confirm_manual_retry": "¿Está seguro de que desea volver a intentar este pago?",
      "shopify_maneged": "Shopify gestiona esta suscripción. Puedes gestionarla desde tu panel de administración de Shopify.",
      "unknown_plan": "Plan desconocido"
    }
  },
  "domain_listing": {
    "select": "Selecciona un dominio",
    "add": "Agregar sitio web"
  },
  "editable": {
    "number": "número {{id}}"
  },
  "footer": {
    "about": "Acerca de",
    "support": "Soporte"
  },
  "frontendEditor": {
    "main": "Editor en vivo",
    "description": "El editor en vivo te ayuda a editar las traducciones directamente en tu sitio web.",
    "button": "Abrir editor en vivo",
    "language_selection": "Selección de idioma de traducción",
    "video_label": "Aprenda a utilizar el editor en vivo"
  },
  "general": {
    "403": {
      "tab_title": "Ups - Error 403",
      "title": "Acceso denegado",
      "message": "Parece que no tiene acceso a la página solicitada.",
      "home": "Regresar al inicio"
    },
    "404": {
      "tab_title": "Ups - Error 404",
      "title": "Página no encontrada",
      "message": "Parece que obtuviste un giro errado. No te preocupes... Esto le pasa a los mejores de nosotros. Aquí está un pequeño tipo que podría ayudarte a volver al camino.",
      "home": "Regresar al inicio"
    },
    "500": {
      "tab_title": "Error 500",
      "title": "Error interno del servidor",
      "message": "¿Por qué no intentas refrescando la página? También puedes contactarnos",
      "home": "Regresar al inicio"
    },
    "fields": {
      "alert": "Algunos campos no son válidos, por favor corrija los campos erróneos.",
      "invalid": "Este campo es erróneo",
      "phone_re": "El número de teléfono no es válido",
      "phone_invalid": "El número de teléfono no es válido",
      "email": "El campo de correo electrónico no es válido"
    },
    "saving": "Guardando ...",
    "save": "Guardar",
    "save_and_quit": "Guardar y salir",
    "invite": "Invitar",
    "cancel": "Cancelar",
    "yes": "Sí",
    "no": "No",
    "nextStep": "Siguiente paso",
    "loading": "Por favor espere mientras carga la aplicación",
    "goback": "Regresar",
    "manage": "Administrar",
    "delete": "Eliminar",
    "deleting": "Eliminando ...",
    "table": {
      "no_data": "Aún no hay datos aquí..."
    },
    "confirm": "Confirmar",
    "unknown": "Desconocido",
    "hide": "Esconder",
    "show": "Espectáculo",
    "on": "En",
    "off": "Apagado",
    "default": "Predeterminado"
  },
  "home": {
    "header": "Panel",
    "manage": "Administrar suscripción",
    "activate_now": "Activar ahora",
    "activate_plan_now": "Suscríbase ahora",
    "upgrade_plan_now": "Actualizar plan ahora",
    "trial_message_part_1": "Actualmente estás en el plan de prueba, ",
    "trial_message_part_2": "puedes activar una membresía en cualquier momento.",
    "add": "Agregar dominio",
    "table": {
      "title": "Dominios",
      "description": "Lista de tus dominios, haz clic en el dominio para gestionar las traducciones"
    },
    "domains": {
      "empty": "No tienes ningún dominio en esta cuenta"
    },
    "accountsList": {
      "title": "Cuentas",
      "add": "Agregar nueva cuenta",
      "name": "Nombre de la cuenta"
    },
    "update_credit_card": "Actualizar los datos de la tarjeta de crédito",
    "canceled": "Suscripción cancelada",
    "cancelling_subs": "Cancelando en {{0}}",
    "resume_subscription": "Reanudar suscripción",
    "shopify_managed": "Administrado por Shopify",
    "trial_ends_at": "Termina en {{0}}",
    "free_trial": "Prueba gratuita",
    "no_subs": "Sin suscripción activa"
  },
  "invoices": {
    "title": "Facturas",
    "list": {
      "title": "Lista de facturas"
    },
    "table": {
      "customer": "Clientes",
      "domain": "Dominios",
      "amountPaid": "Monto pagado",
      "status": "Estado",
      "date": "Fecha",
      "invoice": "Factura",
      "pay": "pagar factura",
      "actions": "Comportamiento",
      "deleted_domain": "Dominio eliminado",
      "plan_name": "Plan",
      "action": "Acción"
    },
    "listPending": {
      "title": "Lista de facturas pendientes"
    }
  },
  "language_settings": {
    "display": "Visualización de la lista de idiomas",
    "position": "Posición",
    "display_help_text": "Mostrar nombres de banderas y/o idiomas. La posición predeterminada del conmutador de idioma podría estar en cualquier parte del contenido o en una posición fija que permanezca fija o se mueva en el desplazamiento",
    "side_by_side": "Lado a lado",
    "dropdown": "Desplegable",
    "popup": "Surgir",
    "flag": "Bandera",
    "lang_name": "Nombre del lenguaje",
    "lang_short_name": "Nombres cortos",
    "positions": {
      "in_place": "En su lugar",
      "top_left": "Arriba a la izquierda",
      "top_left_no_scroll": "Arriba a la izquierda (sin desplazamiento)",
      "top_right": "Parte superior derecha",
      "top_right_no_scroll": "Arriba a la derecha (sin desplazamiento)",
      "bottom_left": "Abajo a la izquierda",
      "bottom_left_no_scroll": "Abajo a la izquierda (sin desplazamiento)",
      "bottom_right": "Abajo a la derecha",
      "bottom_right_no_scroll": "Abajo a la derecha (sin desplazamiento)"
    },
    "lang_names_display": {
      "title": "Visualización de nombres de idiomas",
      "help_text": "En el selector de idiomas, muestra los nombres de los idiomas en inglés o en el idioma original, es decir, francés o francés.",
      "english": "Inglés",
      "native_languages": "Lenguaje nativo"
    },
    "flag_shape": {
      "title": "Estilo de bandera",
      "help_text": "Use iconos de bandera svg redondos o rectangulares svg",
      "round": "Redondo",
      "rectangular": "Rectangular"
    },
    "english_flag_type": {
      "title": "Tipo de bandera inglesa",
      "help_text": "Use la bandera de Gran Bretaña o EE. UU. para inglés",
      "usa": "Bandera de EE.UU",
      "great_britain": "Bandera de gran bretaña"
    },
    "german_flag_type": {
      "title": "Tipo de bandera alemana",
      "help_text": "Use la bandera de Austria o Alemania para alemán",
      "german": "Bandera alemana",
      "austria": "Bandera austríaca"
    },
    "spain_flag_type": {
      "title": "Tipo de bandera española",
      "help_text": "Use la bandera de México o España para español",
      "spanish": "Bandera española",
      "mexico": "Bandera de México",
      "peruvian": "Bandera Peruana"
    },
    "portugal_flag_type": {
      "title": "Tipo de bandera portuguesa",
      "help_text": "Use la bandera portuguesa o brasileña para portugués",
      "portugal": "Bandera portuguesa",
      "brazil": "Bandera brasileña"
    },
    "taiwanese_flag_type": {
      "title": "Tipo de bandera taiwanesa",
      "help_text": "Utilice la bandera taiwanesa o china para los taiwaneses",
      "taiwanese": "Bandera taiwanesa",
      "chinese": "Bandera china"
    },
    "flag_border_radius": {
      "title": "Radio del borde de la bandera (px)",
      "help_text": "Si está utilizando la forma de la bandera del rectángulo, puede aplicar un radio de borde personalizado en píxeles"
    },
    "flag_width": {
      "title": "Tamaño de la bandera (px)",
      "help_text": "Seleccione el tamaño de las banderas en píxeles. Eso no cambia el peso de la imagen ya que es un formato .svg"
    },
    "lang_color": {
      "color_title": "Color del nombre del idioma",
      "color_help_text": "Seleccione un color de texto predeterminado para los nombres de sus idiomas",
      "hover_color_title": "Color de desplazamiento del nombre del idioma",
      "hover_color_help_text": "Seleccione un color de texto de desplazamiento del mouse para los nombres de su idioma",
      "color_popup_title": "Color de idioma emergente",
      "color_popup_help_text": "Color del título del idioma en la ventana emergente o en las áreas desplegables",
      "hover_color_popup_title": "Color de desplazamiento del idioma emergente",
      "hover_color_popup_help_text": "Seleccione un color de texto de desplazamiento del mouse del título del idioma en la ventana emergente o en las áreas desplegables"
    },
    "flag_box_shadow": {
      "shadow_title": "Sombra de cuadro de bandera",
      "shadow_help_text": "Color y tamaño de sombra para las banderas de su idioma",
      "hover_shadow_title": "Sombra de cuadro de bandera al pasar el mouse",
      "hover_shadow_help_text": "Color y tamaño de sombra para las banderas de su idioma al pasar el mouse",
      "shadow_h_offset": "Desplazamiento de sombra H (px)",
      "shadow_v_offset": "Desplazamiento de sombra V (px)",
      "shadow_blur": "Desenfoque de sombra (px)",
      "shadow_spread": "Extensión de la sombra (px)",
      "shadow_color": "Color de sombra"
    },
    "order": "Orden de idiomas",
    "language_order_help": "El orden del idioma que se mostrará en el selector de idiomas. Puedes arrastrar y soltar el idioma para reordenarlos. ",
    "order_reset": "Restablecer orden",
    "language_order_dragdrop": "Puedes arrastrar y soltar el idioma para reordenarlos.",
    "popup_lang_name": "Nombre del idioma de la ventana emergente",
    "preview": "Vista previa del idioma"
  },
  "link": {
    "form": {
      "original": {
        "title": "Fuente original",
        "description": "Agregue la URL de su enlace original y reemplácela a continuación por idioma para traducirlos",
        "srcset_description": "Estás editando la URL de una imagen. Asegúrese de leer la documentación, especialmente si usa srcset o no sabe qué es",
        "link": "Enlace",
        "match_link": "Modo de partido",
        "match_exact": "Exacto",
        "match_wildcard": "Comodín",
        "match_regex": "Expresión regular"
      },
      "alternative_languages": {
        "title": "Enlaces para reemplazar",
        "description": "Reemplace los enlaces de medios y los enlaces externos en todas sus páginas, por idioma...",
        "link": "Enlace para reemplazar"
      },
      "error": {
        "atLeastOne": "Por favor agregue al menos una traducción.",
        "url": "La URL no es válida",
        "extension": "El enlace debe tener una extensión, pero no puede ser .html o .php. Y el enlace no debe contener ninguna ruta de idioma, p. \"/fr\"",
        "regex": "La expresión regular no es válida",
        "wildcard": "El enlace comodín tiene un protocolo no válido"
      }
    },
    "main": {
      "parent": "Enlaces",
      "edit": "Editar enlace"
    }
  },
  "links": {
    "title": "Gestión de medios y enlaces externos",
    "description": "Enumere y edite su sitio web Enlaces de medios o enlaces externos.",
    "add": "Añadir enlace",
    "delete": "Eliminar enlace",
    "table": {
      "original": "Original",
      "language": "Idioma",
      "translation": "Traducción",
      "action": "Acción",
      "delete_confirm": "Por favor, confirme la eliminación del enlace."
    }
  },
  "members": {
    "header": "Miembros",
    "invite": "Invitar a un nuevo miembro",
    "modal": {
      "inviteHeader": "Invitar a un nuevo miembro",
      "editHeader": "Editar miembro",
      "detachHeader": "Separar miembro",
      "detachBody": "¿Está seguro de que desea desvincular al miembro de esta cuenta?",
      "selfDetachBody": "¿Estás seguro de que quieres desvincularte de esta gestión de cuentas? Después de eso, no podrá acceder a ninguno de los datos relacionados con esta cuenta. "
    },
    "table": {
      "title": "Lista de miembros",
      "description": "Roles de miembros y acceso a dominios",
      "name": "Nombre",
      "email": "Email",
      "websites": "Sitios web",
      "languages": "Idiomas",
      "role": "Papel",
      "status": "Estado",
      "resendInvite": "reenviar",
      "inviteSent": "se envió la invitación",
      "actions": "Comportamiento",
      "edit": "Editar",
      "detach": "Despegar",
      "empty": "Aún no tienes miembros",
      "all_website": "Todos los sitios web e idiomas",
      "roles": {
        "admin": "Administrador",
        "manager": "Gerente",
        "translator": "Traductor"
      },
      "statuses": {
        "pending": "Pendiente",
        "accepted": "Aceptado",
        "declined": "Rechazado"
      }
    },
    "errors": {
      "role": "Debes elegir un rol",
      "domains": "Debes elegir al menos 1 sitio web para la función seleccionada",
      "languages": "Debe elegir al menos 1 idioma para los sitios web seleccionados"
    },
    "inviteSent": "Su invitación ha sido enviada con éxito"
  },
  "pagination": {
    "showing": "Mostrando {{limit}} de {{total}} resultados",
    "showing_only_count": "Mostrando {{limit}} resultados"
  },
  "payments_method": {
    "header": "Métodos de pago",
    "table": {
      "title": "Lista de métodos de pago",
      "description": "Métodos de pago adjuntos a su cuenta",
      "default": "Por defecto",
      "action_edit_remove": "Editar o eliminar",
      "action_remove": "Eliminar",
      "action_default": "Establecer como predeterminado",
      "action_fallback": "Establecer como alternativa",
      "expires": "Vence",
      "add_new_card": "Agregar método de pago",
      "action_fallback_remove": "Quitar del respaldo",
      "fallback": "Retroceder",
      "action_edit": "Editar",
      "action_delete": "Borrar",
      "action_default_remove": "Eliminar como predeterminado",
      "domain_count@@one": "Utilizado por {{count}} dominios",
      "domain_count@@other": "Utilizado por {{count}} dominios"
    },
    "paypal_bind": {
      "button": "Conectar cuenta PayPal",
      "button_load": "Conectando...",
      "disconnected": "No conectado",
      "error": "Ha ocurrido un error",
      "success_header": "Éxito",
      "success_no_promo": "Su cuenta PayPal ahora está conectada",
      "success": "Su cuenta PayPal ya está conectada, ¡se deducirán $5 de su próxima factura!"
    },
    "card_add": {
      "header": "Agregar nueva tarjeta",
      "success": "¡Nueva tarjeta conectada a Linguise!",
      "terms": "Al proporcionar la información de su tarjeta, permite que Linguise cargue en su tarjeta pagos futuros de acuerdo con nuestros términos de servicio."
    },
    "card_detail": {
      "header": "Información de la tarjeta",
      "delete": {
        "error": "¡No puedes eliminar este método de pago porque tiene suscripciones activas!"
      }
    },
    "subscriptions": {
      "table": {
        "description": "Suscripciones en este método de pago",
        "header_domain": "Dominio",
        "header_plan": "Plan",
        "header_status": "Estado",
        "header_actions": "Comportamiento",
        "cancelling": "Cancelando en: {{0}}",
        "next_payment": "Próximo pago en: {{0}}",
        "action_renew": "Renovar",
        "no_subs_header": "No hay suscripciones para mostrar",
        "no_subs_desc": "Una vez realizada la suscripción a esta tarjeta, toda la información se mostrará aquí",
        "action_manage": "Administrar"
      },
      "status": {
        "active": "Activo",
        "canceled": "Cancelado",
        "incomplete": "No pagado",
        "incomplete_expired": "No pagado (vencido)",
        "past_due": "Vencido",
        "trialing": "Ensayo",
        "unpaid": "No pagado",
        "missing": "Error"
      }
    },
    "delete_confirm_body": "¿Estás seguro de que deseas eliminar este método de pago? ¡Esta acción no se puede revertir!",
    "delete_confirm_header": "¿Eliminar método de pago?",
    "card_edit": {
      "header": "Editar tarjeta",
      "billing_header": "Información de facturación",
      "address_error": "¡Se requiere dirección!",
      "card_number": "Número de tarjeta",
      "card_expiry": "Fecha de expiración",
      "expiry_error_month": "Mes proporcionado no válido",
      "expiry_error_year": "Año proporcionado no válido",
      "expiry_error_expired": "El año de vencimiento de su tarjeta ya pasó.",
      "card_header": "Información de la tarjeta",
      "expiry_error_empty": "¡Este campo es obligatorio!"
    }
  },
  "plans": {
    "per": "por",
    "wordsTranslated": "palabras traducidas",
    "current": "Actual",
    "archived": "Archivados",
    "day": "día",
    "week": "semana",
    "month": "mes",
    "year": "año",
    "activate": "Activar",
    "cancel": "Cancelar",
    "change": "Cambiar",
    "upgrade": "Mejorar",
    "downgrade": "Degradar",
    "notEnoughWords": "No hay suficientes palabras",
    "yearIntervalOnly": "No se puede migrar desde el plan anual",
    "wordsUnlimited": "Palabras ilimitadas",
    "tabs": {
      "day": "Precios diarios",
      "week": "Precios semanales",
      "month": "Precios mensuales",
      "year": "Precios anuales",
      "sub_texts": {
        "day": "Un precio fijo, todos los días",
        "week": "Un precio fijo, cada semana",
        "month": "Un precio fijo, cada mes",
        "year": "Un mes gratis, una factura al año"
      }
    },
    "details": {
      "new_languages": "Añade nuevos idiomas en cualquier momento",
      "one_month_trial": "Prueba gratuita de un mes para cada nuevo sitio web",
      "multi_content_indexed": "100% del contenido multilingüe indexado",
      "translate_new_content": "Traduce contenido nuevo al instante",
      "free_installation": "Instalación y configuración gratuitas",
      "compared_monthly_plan": "Un mes gratis en comparación con los planes mensuales",
      "risk_free_recurring": "Fallo de pago recurrente sin riesgos",
      "unlimited_languages": "Idiomas y vistas de páginas ilimitados",
      "high_server_resources": "Altos recursos del servidor",
      "billed": {
        "day": "Facturado diariamente",
        "week": "Facturado semanalmente",
        "month": "Facturado mensualmente",
        "year": "Facturado anualmente"
      },
      "request_max_size": "Tamaño máximo de solicitud de {{0}}"
    },
    "frequent_question": {
      "title": "Preguntas frecuentes",
      "questions": {
        "trial": {
          "question": "¿Puedo utilizar la prueba en un nuevo dominio de sitio web?",
          "answer": "Sí, ofrecemos una prueba gratuita de 30 días por cada nuevo dominio de sitio web que agregue a su cuenta. De esta manera, podrás probar completamente el servicio de traducción en tu nuevo sitio web."
        },
        "seo": {
          "question": "¿Cuánto tiempo tarda mi SEO en mejorar?",
          "answer": "El contenido y el contenido multilingüe toman tiempo para estar completamente indexados y bien clasificados. Dependiendo del tráfico y el tamaño de su sitio web, es entre 3 y 6 semanas."
        },
        "quota": {
          "question": "¿Las traducciones humanas están incluidas en la cuota?",
          "answer": "No, el límite de recuento de palabras es solo para traducciones automáticas. Un traductor puede editar manualmente traducciones automáticas sin límite."
        }
      }
    },
    "best_offer": "Mejor oferta",
    "resume": "Reanudar",
    "subsCanceled": "Hay otra cancelación de suscripción en curso.",
    "period": {
      "days@@one": "día",
      "days@@other": "{{count}} días",
      "hours@@one": "hora",
      "hours@@other": "{{count}} horas",
      "minutes@@one": "minuto",
      "minutes@@other": "{{count}} minutos",
      "seconds@@one": "segundo",
      "seconds@@other": "{{count}} segundos"
    },
    "words": {
      "billion": "{{value}}000 M",
      "million": "{{value}} M",
      "thousand": "{{value}} mil"
    },
    "throttling_info": "{{words}} palabras por {{period}}"
  },
  "profile": {
    "welcome": "¡Bienvenido!",
    "account": "Mi cuenta",
    "subscriptions": "Suscripciones",
    "logout": "Cerrar sesión"
  },
  "register": {
    "errors": {
      "password": "Mínimo 8 caracteres, cualquier carácter"
    }
  },
  "route": {
    "dashboard": "Panel",
    "rules": "Reglas",
    "translations": "Traducciones",
    "search_translations": "Traducción de investigación",
    "urls_translations": "Traducciones de URLs",
    "links": "Medios y enlaces externos",
    "online_editor": "Editor en vivo",
    "settings": "Configuración",
    "domain": {
      "finish": "Configuración",
      "preconfig": "Configuración"
    },
    "home": "Panel",
    "domain_list": "Lista de dominios",
    "members": "Miembros",
    "invoices": "Factura",
    "billing": "Detalles de factura",
    "language_display": "Visualización de banderas de idioma",
    "payment_methods": "Métodos de pago",
    "ai_translation": "Traducción de IA",
    "ai_translation_settings": "Ajustes",
    "ai_translation_pricing": "Precios"
  },
  "rule": {
    "form": {
      "text_ignore": {
        "placeholder": "Texto a ignorar",
        "add": "Añadir nuevo",
        "title": "Texto a ignorar",
        "description": "Añade uno o varios textos a ignorar",
        "ignore_case": "Ignorar mayúscula/minúscula"
      },
      "html_content": {
        "title": "Aplicar a contenido html",
        "description": "Aplicar las reglas a todo tu contenido o selecciona un selector CSS en específico",
        "all_page": "Toda la página",
        "css_selector": "Selector CSS",
        "label": "Selector CSS",
        "placeholder": "Selector CSS al que será aplicado",
        "add": "Añadir nuevo"
      },
      "apply_to_urls": {
        "title": "Aplicar a URLs",
        "description": "Selecciona URLs en específico donde quieres aplicar la regla",
        "all_urls": "Todas las URLs",
        "selected_urls": "URLs seleccionadas",
        "label": "Url al que será aplicada",
        "placeholder": "Url al que será aplicada",
        "original_url": "URLs originales",
        "translated_url": "URL traducida",
        "wildcard": "Comodín",
        "regex": "Expresión regular",
        "add": "Añadir nuevo",
        "expression": "Tipo de expresión"
      },
      "apply_urls": {
        "title_exclude": "Excluir en URLs",
        "title_replace": "Reemplazar en URLs",
        "title_description": "Aplicar esta regla también a la traducción de las URLs"
      },
      "apply_languages": {
        "title": "Aplicar a los idiomas",
        "description": "Puedes seleccionar un idioma en específico al que quieres aplicarle la regla",
        "all_languages": "Todos los idiomas",
        "selected_languages": "Idiomas seleccionados",
        "placeholder": "Seleccionar idiomas...",
        "feedback": "Tienes que elegir un idioma"
      },
      "name": {
        "title": "Título",
        "description": "Asignale a tu regla un título por conveniencia",
        "placeholder": "Nombre de regla"
      },
      "type": {
        "title": "Tipo",
        "description": "Escoge el tipo de regla que quieres añadir",
        "text_ignore": "Ignorar texto",
        "text_replace": "Reemplazar texto",
        "content_exclusion": "Excluir contenido",
        "url_exclusion": "Exclusion de traducción de URL",
        "ignore_inline": "Ignorar en línea",
        "full_description": {
          "text_ignore": "Agrega reglas para evitar traducir texto. Este podría ser el nombre de tu producto, el nombre de tu marca o algún otro elemento técnico que no quieres que sea traducido.",
          "text_replace": "Reemplazo de texto te permite reemplazar un texto con la traducción que desees, esto podría ser necesario cuando la traducción ignora el contexto.",
          "content_exclusion": "La exclusión de contenido te ayudará a evitar la traducción de un contenido en la página.\n Si quieres excluir completamente una página de la traducción (Sin URL multilingüe para esta página ni contenido traducido) por favor utiliza el tipo \"exclusión de traducción de URL\" ",
          "url_exclusion": "La exclusión de traducción de la página te ayudará a seleccionar las páginas que no quieres traducir.",
          "ignore_inline": "Evite traducir parte del contenido como contenido en línea; en su lugar, traduzca cada etiqueta por separado."
        }
      },
      "text_replace": {
        "title": "Texto a reemplazar",
        "description": "Reemplaza un texto con tu traducción específica, puedes reemplazar un texto en toda tu página, por idioma…",
        "text_to_replace": "Texto a reemplazar",
        "ignore_case": "Ignorar mayúscula/minúscula",
        "text_type": "Reemplazo en la traducción",
        "text_type_original": "Original",
        "text_type_translation": "Traducción",
        "keep_case": "Intentar mantener mayúscula/minúscula",
        "add": "Añadir nuevo"
      },
      "content_exclusion": {
        "title": "Exclusión de contenido",
        "description": "Seleccionar uno o más selectores CSS que no serán traducidos",
        "label": "Selector CSS",
        "placeholder": "Selector al que se le aplicará",
        "add": "Añadir nuevo"
      },
      "multilingual_url": {
        "title": "Usar URL multilinüe",
        "description": "Si selecciona sí, La URL NO será traducida pero la página permanecerá multilingüe con el contenido traducido",
        "live_example_title": "Ejemplo en vivo",
        "live_example_description": "URL origen: https://tusitioeb.com/pagina-no-traducida",
        "live_example_multilingual": "URL generada: https://tusitioweb.com/fr/pagina-no-traducida",
        "live_example_no_multilingual": "URL generada: https://tusitioweb.com/pagina-no-traducida"
      },
      "rule_application": {
        "description": "Aplicar la regla sobre contenido estático o contenido dinámico o ambos",
        "title": "Aplicar al contenido",
        "all": "Todo contenido",
        "static": "Contenido estático",
        "dynamic": "Contenido dinámico"
      },
      "force_apply_urls": {
        "title_description": "¡La fuerza aplica esta regla a todas las traducciones de URL, incluidas las traducciones existentes!",
        "title_replace": "Fuerza reemplazar en URLS",
        "title_exclude": "Excluir en URLS",
        "warning": "Advertencia",
        "warning_part1": "Establecer esto en \"Sí\" podría romper las traducciones de URL de su sitio web.",
        "warning_part2": "Esto puede generar temporal o permanentemente una página de 404s, solo continúe si comprende las consecuencias.",
        "warning_replacement_original": "Advertencia adicional: está tratando de reemplazar el contenido original que podría afectar la URL, la traducción podría fallar ya que Linguise no puede encontrar las URL originales correctamente"
      }
    },
    "main": {
      "parent": "Reglas",
      "edit": "Editar reglas",
      "add": "Nueva regla"
    }
  },
  "rules": {
    "text_ignore": {
      "preview_single_with_url": "\"{{text_ignore}}\" será ignorado en el contenido y la URL",
      "preview_single": "\"{{text_ignore}}\" será ignorado en el contenido",
      "preview_more_with_url": "\"{{text_ignore}}\" y {{count}} más serán ignorados en el contenido",
      "preview_more": "\"{{text_ignore}}\" y {{count}} más serán ignorados en el contenido",
      "other_parameters": "Otros parámetros son configurados por esta regla, haz clic al botón de editar para obtener más información"
    },
    "text_replace": {
      "preview_single_with_url": "\"{{original}}\" es reemplazado por \"{{replacement}}\" en el contenido y la URL",
      "preview_single": "\"{{original}}\" es reemplazado por \"{{replacement}}\" en el contenido",
      "preview_more_with_url": "\"{{original}}\" es reemplazado por \"{{replacement}}\" en el contenido y las URLs, y {{nb}} más",
      "preview_more": "\"{{original}}\" es reemplazado por \"{{replacement}}\" en el contenido, y {{nb}} más",
      "other_parameters": "Otros parámetros son configurados por esta regla, haz click al botón de editar para obtener más información"
    },
    "content_exclusion": {
      "selectors": "{{nb}} selector(es) CSS excluidos de la traducción",
      "other_parameters": "Otros parámetros son configurados por esta regla, haz clic al botón de editar para obtener más información"
    },
    "url_exclusion": {
      "some_multilingual": "{{nb}} URLs están excluidas de la traducción, pero aún mantienen el prefijo multilingüe",
      "some": "{{nb}} URLs excluidas completamente de la traducción",
      "all_multilingual": "todas las URLs estan excluidas de la traducción, pero aún mantienen el prefijo multilingüe",
      "all": "todas las URLs están completamente excluidas de la traducción",
      "other_parameters": "Otros parámetros son configurados por esta regla, haz clic al botón de editar para obtener más información"
    },
    "ignore_inline": {
      "elements": "Todo el contenido en línea se traducirá como contenido de bloques en la página.",
      "all_elements": "Parte del contenido en línea se traducirá como contenido de bloques en la página.",
      "other_parameters": "Se establecen otros parámetros para esta regla, haga clic en el botón editar para obtener más información"
    },
    "title": "Administrador de reglas",
    "description": "Administra las reglas de exclusión de traducción de tu contenido y reemplazo en todo tu sitio",
    "add": "Añadir nueva regla",
    "table": {
      "title": "Titulo",
      "type": "Tipo",
      "preview": "Previsualización de regla",
      "action": "Acción",
      "delete_confirm": "Por favor confirme la eliminación de la regla",
      "types": {
        "text_ignore": "Ignorar texto",
        "text_replace": "Reemplazo de texto",
        "content_exclusion": "Exclusión de contenido",
        "url_exclusion": "Exclusión de URL",
        "ignore_inline": "Ignorar en línea",
        "unknown": "regla desconocida"
      },
      "no_data": "Aún no hay reglas aquí"
    },
    "apply_on_content": {
      "static": "Esta regla solo se aplicará al contenido estático.",
      "dynamic": "Esta regla solo se aplicará al contenido dinámico."
    }
  },
  "search_translations": {
    "title": "Gestión de búsqueda de traducciones",
    "description": "Enumere todas las traducciones de su sitio web utilizadas a través de los formularios de búsqueda (desde el idioma traducido al idioma base de su dominio)",
    "filter_languages": "Filtra por idiomas...",
    "filter_original": "Filtra texto en el idioma original",
    "filter_translation": "Filtra por texto traducido",
    "table": {
      "original": "Original",
      "language": "Idioma",
      "translation": "Traducción"
    }
  },
  "subscription": {
    "failure": {
      "tab_title": "¡No se pudo suscribir!",
      "title": "¡No se pudo suscribir!",
      "subtitle": "Se ha producido un error al intentar procesar su suscripción.",
      "home": "volver a casa",
      "generic": "Se ha producido un error desconocido en Linguise, ¡póngase en contacto con el administrador!"
    },
    "success": {
      "home": "Administrar traducciones de dominio",
      "message": "Estamos comprometidos a brindarle la mejor experiencia de traducción posible. Nuestro equipo de expertos está disponible para ayudarle con cualquier pregunta o apoyo que pueda necesitar. Para comenzar, simplemente haga clic en el botón a continuación.",
      "subtitle": "Gracias por elegir el servicio de traducción Linguise",
      "title": "¡Suscripción activada!",
      "tab_title": "¡Gracias por la suscripción!"
    }
  },
  "subscriptions": {
    "edit": {
      "title": "Administrar suscripciones"
    },
    "list": {
      "title": "Lista de suscripciones",
      "description": "Lista de suscripción de tus dominios"
    },
    "table": {
      "domain": "Dominios",
      "plan": "Plan",
      "status": "Estado",
      "card": "Tarjeta",
      "usage": "Uso",
      "actions": "Acciones",
      "payment_method": "Método de pago"
    },
    "usage": {
      "paid": "{{words_used}} / {{words_allowed}} palabras",
      "paidOffered": "{{words_used}} / {{words_allowed}} palabras\n(Incluidas {{free_words}} palabras ofrecidas)"
    },
    "success": {
      "tab_title": "¡Suscripción activada!",
      "title": "¡Suscripción activada!",
      "subtitle": "Gracias por elegir el servicio de traducción Linguise",
      "message": "'Estamos comprometidos a brindarle la mejor experiencia de traducción posible. Nuestro equipo de expertos está disponible para ayudarle con cualquier pregunta o apoyo que pueda necesitar. Para comenzar, simplemente haga clic en el botón a continuación.",
      "home": "Administrar traducciones de dominio"
    },
    "popup": {
      "dueToday": "Total adeudado hoy",
      "nextPeriod": "A partir del {{date}}"
    }
  },
  "topbar": {
    "accounts": {
      "choose": "Elige una cuenta"
    }
  },
  "translation": {
    "main": {
      "parent": "Traducciones",
      "edit": "Editar traducciones"
    },
    "form": {
      "original": {
        "title": "Original en {{language}}"
      },
      "is_inline": "Esta traducción está hecha desde el contenido en línea.",
      "inline_editor": {
        "count_warning": "El número de áreas integradas no coincide con el original ({{current}} de {{expected}}).",
        "restore_original": "Restaurar texto original",
        "insert_placeholder": "Insertar marcador de posición",
        "drag": "Arrastra para reordenar el área integrada",
        "area": "Área en línea {{index}}",
        "restore": "Restaurar las áreas integradas que faltan"
      },
      "translation": {
        "title": "Traducción en {{language}}",
        "description": "Traducción que quieres sobrescribir"
      }
    },
    "copy": {
      "title": "Copiar en la traducción manual",
      "label": "Copiar en manual"
    },
    "level": {
      "base": {
        "title": "Traducción base",
        "subtitle": "Automática · traducción de Linguise Cloud",
        "empty": "No hay traducción base para este texto.",
        "overridden": "Tu elección está guardada, pero en su lugar se muestra la traducción mejorada con IA más reciente porque «Sobrescribir traducciones manuales y seleccionadas» está en «Sí» en la configuración de traducción de IA. Desactiva esa opción para usar tu elección."
      },
      "not_generated": "No generada",
      "none": "Nada todavía",
      "ai": {
        "title": "Traducción mejorada con IA",
        "subtitle": "Automática · Linguise AI",
        "empty_title": "Aún no generada para este texto",
        "empty_description": "Linguise AI ofrece traducciones más naturales usando el contexto de tu página y de tu sitio web. Para obtener una aquí:",
        "empty_step_1": "Ve a Traducción de IA › Configuración y establece Habilitar la traducción de IA en «Solo reglas», «Solo editor en vivo» o «Reglas y editor en vivo».",
        "empty_step_2": "Aplícala con una regla que coincida con esta página, o habilítala página por página desde el editor en vivo.",
        "empty_step_3": "La traducción mejorada con IA aparecerá aquí una vez generada. Consume tus créditos de IA.",
        "open_settings": "Abrir la configuración de traducción de IA",
        "open_editor": "Abrir el editor en vivo",
        "overrides_selection": "Tu elección está guardada, pero en su lugar se muestra esta traducción mejorada con IA porque «Sobrescribir traducciones manuales y seleccionadas» está en «Sí» en la configuración de traducción de IA. Desactiva esa opción para usar tu elección.",
        "overrides_version": "La versión que elegiste está guardada, pero en su lugar se muestra la versión mejorada con IA más reciente porque «Sobrescribir traducciones manuales y seleccionadas» está en «Sí» en la configuración de traducción de IA. Desactiva esa opción para usar la versión elegida."
      },
      "manual": {
        "title": "Traducción manual",
        "subtitle": "Escrita por ti · tiene prioridad sobre las traducciones automáticas",
        "empty": "Vacía",
        "saved_but_overridden": "Guardada como tu elección, pero no se muestra automáticamente porque «Sobrescribir traducciones manuales» está en «Sí» en la configuración de traducción de IA: la traducción mejorada con IA prevalece hasta que desactives esa opción.",
        "ignored": "No se muestra automáticamente porque «Sobrescribir traducciones manuales» está en «Sí» en la configuración de traducción de IA. Selecciónala para usarla en este texto.",
        "label": "Tu traducción",
        "placeholder": "Escribe tu propia traducción...",
        "last_updated": "Última edición: {{date}}",
        "save_hint": "Al guardar una traducción manual, esta pasa a estar activa.",
        "delete": "Eliminar traducción manual",
        "delete_confirm": "Por favor, confirma la eliminación de la traducción manual"
      }
    },
    "history": {
      "title": "Versiones mejoradas con IA",
      "subtitle": "Se conserva cada regeneración desde el editor en vivo",
      "unknown_model": "Modelo desconocido",
      "current": "Actual",
      "restore": "Restaurar esta versión",
      "restore_note": "Al restaurar, esa versión pasa a ser la traducción mejorada con IA actual. No se elimina nada.",
      "version_of": "Versión {{current}} de {{total}}",
      "hide": "Ocultar historial ({{total}})",
      "show": "Mostrar historial ({{total}})"
    },
    "choose": {
      "title": "Traducciones en {{language}} · elige cuál ven los visitantes",
      "current": "Actualmente en tu sitio web:",
      "priority": "Prioridad predeterminada: Manual › Mejorada con IA › Base. Tu elección se guarda solo para esta traducción.",
      "reset": "Restablecer la prioridad predeterminada",
      "reset_title": "Olvidar tu elección para este texto y volver a usar la prioridad predeterminada",
      "resetting": "Restableciendo ..."
    }
  },
  "translations": {
    "title": "Administrar traducciones",
    "description": "Enlista y edita todas las traducciones de tu sitio web. Para una traducción visual utiliza el editor en vivo",
    "filter_languages": "Filtra por idiomas...",
    "filter_original": "Filtra texto en el idioma original",
    "filter_translation": "Filtra por texto traducido",
    "table": {
      "original": "Original",
      "language": "Idioma",
      "action": "Acción",
      "base": "Base",
      "ai": "Mejorada con IA",
      "manual": "Manual"
    },
    "filter_exact": "Partido exacto",
    "badge": {
      "active": "Activa",
      "overrides_manual": "Sobrescribe la manual"
    },
    "cell": {
      "none": "ninguna",
      "not_generated": "no generada",
      "ignored": "Ignorada – gana la regla de IA"
    },
    "tabs": {
      "all": "Todas",
      "manual": "Con manual",
      "ai": "Con mejora de IA",
      "base": "Solo base"
    },
    "levels_hint": "Cada texto tiene hasta 3 niveles: el marcado como Activa es el que ven los visitantes."
  },
  "url": {
    "main": {
      "parent": "URLs",
      "edit": "Editar traducción de URL"
    },
    "form": {
      "original": {
        "title": "Original en {{language}}"
      },
      "translation": {
        "title": "Traducción de URL en {{language}}",
        "description": "URL que quieres sobrescribir",
        "placeholder": "Sobrescribe traducción de URL",
        "invalid_full": "Estás intentando cambiar con un formato incorrecto, solo debes cambiar los slugs/nombre de ruta de la traducción de la URL.",
        "invalid": "URL/ruta no válida proporcionada"
      }
    }
  },
  "urls": {
    "title": "Administrador de URLs",
    "description": "Enlista y edita todas las URLs de tu sitio web con contenido traducido (avanzado, ten cuidado con los errores 404)",
    "filter_languages": "Filtrar por idiomas...",
    "filter_original": "Filtrar texto en idioma original",
    "filter_translation": "Filtrar por texto traducido",
    "table": {
      "original": "Original",
      "language": "Idioma",
      "url": "URL traducida",
      "action": "Acción",
      "edited": "La traducción original ha sido editada"
    }
  }
}
